const routes = {
	'/activity-promotion': '活动促销',
};

export {
	routes,
};
